import * as mutations from './mutations.type';
import store from './index'
import { normalizeString } from '../../../support/utils';
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

const loadMunicipios = ({ commit }) => {
  commit(mutations.setIsLoading, true);
  const ibgeCod = store.getters.latestClicked ? store.getters.latestClicked.codigo_ibge : 0
  fetch('./municipios.json')
    .then((response) => response.json())
    .then((data) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].codigo_ibge === ibgeCod) {
          data = data.splice(i, 1).concat(data);
          break;
        }
      }
      commit(mutations.setIsLoading, false)
      commit(mutations.setMunicipios, [...data]);
      commit(mutations.setMunicipiosFiltereds, [...data]);
      return new Promise((resolve) => {
        setTimeout(() => {
          commit(mutations.setIsLoading, false)
        }, 500)
        resolve()
      })
    })
    .catch((error) => {
      commit(mutations.setError, true)
      commit(mutations.setIsLoading, false)
    })
};

const search = ({ commit }, search) => {
  const term = normalizeString(search.term);
  const municipiosFiltereds = search.in.filter(element => {
    return normalizeString(element.nome).indexOf(term.toLowerCase()) > -1;
  });
  commit(mutations.setMunicipiosFiltereds, municipiosFiltereds);
};

export default { loadMunicipios, search };
